import Vue from 'vue';

export default {
    // Busca todos os parâmetros
    listarTodos() {
        return Vue.prototype.$http.get('/parametro');
    },

    // Atualiza um parâmetro (apenas os campos permitidos no backend)
    atualizar(id, parametro) {
        return Vue.prototype.$http.put(`/parametro/${id}`, parametro);
    }
};
